import * as React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody, Card, Button, Spinner
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getVehicle } from "../api/vehicles"
import { getCustomer } from "../api/customers"
import { getDevice } from "../api/devices"
import ReactJson from 'react-json-view';

export default function ViewDeviceVehCustomer({
    idVehicle, idCustomer, idDevice
}) {

    const [open, setOpen] = React.useState(false)
    const [entity, setEntity] = React.useState({})
    const [loadEntity, setLoadEntity] = React.useState(false)

    const onLoadVehicle = async () => {
        try {
            setLoadEntity(true)
            setOpen("Caricamento dati veicolo .....");
            const ve = await getVehicle(idVehicle);
            setEntity(ve);
            setOpen(`Visualizza veicolo ${ve.plate}`)
        } finally {
            setLoadEntity(false)
        }
    }

    const onLoadCustomer = async () => {
        try {
            setLoadEntity(true)
            setOpen("Caricamento dati cliente .....");
            const c = await getCustomer(idCustomer);
            setEntity(c);
            setOpen(`Visualizza cliente ${c.name}`)
        } finally {
            setLoadEntity(false)
        }
    }

    const onLoadDevice = async () => {
        try {
            setLoadEntity(true)
            setOpen("Caricamento dati dispositivo .....");
            const d = await getDevice(idDevice);
            setEntity(d);
            setOpen(`Visualizza dispositivo ${d.imei}`)
        } finally {
            setLoadEntity(false)
        }
    }

    const entityView = () => {
        return (
            <Modal isOpen={open} backdrop={true} size="lg" className="full-screen min-vh-100">
                <ModalHeader toggle={() => setOpen(false)}>
                    {open}
                </ModalHeader>
                <ModalBody>
                    <Card><ReactJson src={entity} theme="solarized" name={open} displayDataTypes={false}></ReactJson></Card>
                </ModalBody>
            </Modal>
        );
    };

    const renderView = () => {
        return (
            <Modal isOpen={open} backdrop={true} size="lg" className="full-screen min-vh-100">
                <ModalHeader toggle={() => setOpen(false)}>
                    {open}
                </ModalHeader>
                <ModalBody>
                    <Card>
                        {loadEntity ? <Spinner /> : <ReactJson src={entity} theme="solarized" name={open} displayDataTypes={false}></ReactJson>}
                    </Card>
                </ModalBody>
            </Modal>
        );
    };


    return (
        <React.Fragment>
            {renderView()}
            <Button color="info" onClick={onLoadDevice} className="btn-sm mr-1">
                <FontAwesomeIcon icon="mobile-alt" />
            </Button>
            <Button color="info" onClick={onLoadCustomer} className="btn-sm mr-1">
                <FontAwesomeIcon icon="user" />
            </Button>
            <Button color="info" onClick={onLoadVehicle} className="btn-sm mr-1">
                <FontAwesomeIcon icon="car" />
            </Button>
        </React.Fragment>
    )
}